/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Icon } from "@coreai/component-library";

import React from "react";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};


const PdfViewer: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  // Inline styles
  const overlayStyle = css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(24, 24, 27, 0.80);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10001;
  `;

  const modalStyle = css`
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    width: 75vw;
    height: 75vh;
    max-width: 100%;
    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  `;

  const closeBtnStyle = css`
    position: absolute;
    top: 15px;
    right: 15px;
    border: none;
    background: none;
    fontSize: 45px;
    cursor: pointer;
    color: white;
  `;
  return (
    <div css={overlayStyle} className="overlayPDFviwer">
        <span css={closeBtnStyle} role="button" tabIndex={1} onClick={onClose}>
          <Icon
            className=""
            counterLabel="Messages"
            counterValue={99}
            name="x-close"
            size="lg"
          />
        </span>
      <div tabIndex={2} css={modalStyle}>
        {children}
      </div>
    </div>
  );
};

export default PdfViewer;
